export default {
  data() {
    return {
      pageResult: {
        totalSize: 0,
        content: []
      },
      istrues: true,
      columnes: [],
      listSearch: [],
      buttonCommonOption: [],
      formCommonSearch: {},
      loads: false,
      page: {
        size: 10,
        current: 1
      },
      typeLists: [],
      fileListes: [],
      indexMenu:'',
      companyListCommon:[]
    }
  },
  created() {

  },
  methods: {
    viewFile(file) {
      let ext = file.url.split('.').pop()
      let imageArr = ['jpg','jpeg','png','gif','bmp']
      //如果是图片 直接打开
      if (imageArr.includes(ext)) {
        let srcList = [file.url]
        this.$imagePreview(srcList, 0)
        return
      }
      // 使用 path（可以带参数）
      const routeData = this.$router.resolve({
        path: '/onlineOfficeViewer',
        query: {
          url: file.url
        }  // 注意：如果是动态路由，需拼接完整路径
      });
      window.open(routeData.href, '_blank');
    },
    remoteMethodCommon(query){
      if(query != '') {
        this.axios.get('customerVisit/customerName?customerName='+ query +'&pageNo=1&pageSize=100').then(res=>{
         
          this.companyListCommon = res.data.data.data
        })
      }else {
        this.companyListCommon = []
      }
    },
    hasPermissions(perms){
      return this.hasPermission(perms)
     },
    viewAppears(str, arr) {
      arr.some((item,index) => {
        item.menu.some((items,indexs) => {
          if(str == items.type) {
            console.log(indexs)
            this.indexMenu = indexs
            return
          }
        })
      })
    },
    getpermission(str,arr){
      let permission = true
      for(let i = 0;i<arr.length;i++) {
        if(arr[i] == str) {
          permission = false
          break
      }
      }
    return permission
    },
    // 判断页面是否加载
    viewAppear(str, arr) {
      for (const i of arr) {
        for (let j of i.menu) {
          if (str == j.type) {
            return true
          }
        }
      }
      return false
    },
    // 导入
    async leadingIn(file, url) {
      let that = this;
      let newFile = new FormData();
      newFile.append("file", file.raw);
      let res = await that.axios.post(url, newFile, {
        headers: { "Content-Type": "multipart/form-data;charset=utf-8" }
      })
      console.log(res)
      if (res == '导入成功' || res.success) {
        this.$message.success('成功')
        return true
      } else {
        this.$message.error(res.msg)
      }
    },
    // 导出2
    leadOut2(url, arr, par, name) {
      if (arr.length == 0) {
        return this.$message.error('请至少选中一项数据')
      }

      this.axios.get(url, {
        params: { [par]: arr.join() },
        headers: { 'Content-Type': 'application/json' },
        responseType: 'arraybuffer',
      }).then(res => {
        if (!res) {
          return
        }
        const blob = new Blob([res], {
          type: 'application/vnd.ms-excel;'
          // type: 'application/doc;'
        })
        const a = document.createElement('a')
        // 生成文件路径
        const href = window.URL.createObjectURL(blob)
        a.href = href
        // const _fileName = res.headers['content-disposition'].split(';')[1].split('=')[1].split('.')[0]
        // 文件名中有中文 则对文件名进行转码
        a.download = decodeURIComponent(name)
        // 利用a标签做下载
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(href)
      })
    },
    // 导出
    leadingOut(url, arr, name) {
      if (arr.length == 0) {
        return this.$message.error('请至少选中一项数据')
      }

      this.axios.post(url, arr, {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'application/json;charset=utf-8' }
      }).then(res => {
        if (!res) {
          return
        }
        const blob = new Blob([res], {
          type: 'application/vnd.ms-excel;'
          // type: 'application/doc;'
        })
        const a = document.createElement('a')
        // 生成文件路径
        const href = window.URL.createObjectURL(blob)
        a.href = href
        // const _fileName = res.headers['content-disposition'].split(';')[1].split('=')[1].split('.')[0]
        // 文件名中有中文 则对文件名进行转码
        a.download = decodeURIComponent(name)
        // 利用a标签做下载
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(href)
      })
    },
    //  业务类型
    async getType() {
      let res = await this.axios.get('/category/getCategoryList', {
        params: { pageNum: 1, pageSize: 1000 },
      });
      if(res.data.code == 200){
        this.$store.commit('editListCommontype', res.data.records)
      }
    },
    // 获取部门
    async getDept() {
      let res = await this.axios.post(
        common.staffUrl + "/pmpc/department/list",
        undefined,
        {}
      );
      console.log(res, 'dept')
      res.data.level = 1
      this.$store.commit('editListCommonDept', [res.data])
    },
    // table表格获取数据
    async getTypeList() {
      let res = await this.axios.get('/category/getCategoryList', {  //params参数必写 , 如果没有可传参数，传{}以
        params: { pageNum: 1, pageSize: 1000 }
      })
      if(res.data.code == 200){
        this.typeLists = res.data.records
      }
    },

    closeAllRe(ref1, ref2) {
      this.$refs[ref1].$refs[ref2].resetFields()
    },
    // 调用接口获取table数据
    getData(url, params, type) {
      // let arr 
      this.loads = true
      if (type == 'get') {
        this.axios.get(url, {  //params参数必写 , 如果没有可传参数，传{}以
          params: params
        }).then(res => {
          console.log(res)
          this.pageResult.totalSize = Number(res.data.total)
          this.pageResult.content = res.data.records
          this.loads = false
        })
      } else {
        this.axios.post(url, params).then(res => {
          console.log(res)
          this.pageResult.totalSize = Number(res.data.total)
          this.pageResult.content = res.data.data||res.data.records
          this.loads = false
        })
      }
      // return arr
    },
    uploadFileCommon(file) {
      let that = this;
      let reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = async function (e) {
        let newFile = new FormData();
        newFile.append("base64File", e.target.result.split(",")[1]);
        newFile.append("originalFilename", file.name);
        if (file.raw.type.indexOf("image") != -1) {
          newFile.append("type", 1);
        } else {
          newFile.append("type", 0);
        }
        let res = await that.axios.post("/file/upload", newFile, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        let obj = {}
        obj.url = res.data[0].url
        obj.name = file.name
        that.fileListes.push(obj);
      };
    },
    handleRemoveCommon(file) {
      this.fileListes.forEach((item, index) => {
        if (this.fileListes[index].name == file.name) {
          this.fileListes.splice(index, 1)
        }
      })
    }
  }
}